import { render, staticRenderFns } from "./OrderCompletion.vue?vue&type=template&id=460740ff"
import script from "./OrderCompletion.vue?vue&type=script&lang=js"
export * from "./OrderCompletion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports